// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../assets/fonts/Gibson-Regular.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Gibson-Regular';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}

.vision-outer-shell {
    display: flex;
    flex-direction: row;
    height: 100vh;
    width: 100vw;
    font-family: 'Gibson-Regular';
}

.nav-container {
    flex: 0 0 auto;
}

.main-app-container {
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
    overflow: hidden;
    overflow-y: scroll;
}

:root {
    --loss: red;
    --gain: green;
}

.chart-divider {
    height: 2.5em;
    background-color: #d80404;
    border: 2px solid black;
    margin-top: -0.5em;
}

.loading-wrapper {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    height: -webkit-fill-available;
}`, "",{"version":3,"sources":["webpack://./src/shell/style.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,+DAAmE;AACvE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;AAClC","sourcesContent":["@font-face {\n    font-family: 'Gibson-Regular';\n    src: url('./../assets/fonts/Gibson-Regular.otf') format('opentype');\n}\n\n.vision-outer-shell {\n    display: flex;\n    flex-direction: row;\n    height: 100vh;\n    width: 100vw;\n    font-family: 'Gibson-Regular';\n}\n\n.nav-container {\n    flex: 0 0 auto;\n}\n\n.main-app-container {\n    flex: 1 1 auto;\n    height: 100%;\n    width: 100%;\n    overflow: hidden;\n    overflow-y: scroll;\n}\n\n:root {\n    --loss: red;\n    --gain: green;\n}\n\n.chart-divider {\n    height: 2.5em;\n    background-color: #d80404;\n    border: 2px solid black;\n    margin-top: -0.5em;\n}\n\n.loading-wrapper {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    height: -webkit-fill-available;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
